<template>
  <v-card max-width="80px" id="card" elevation="0">
    <v-img :aspect-ratio="0.65" v-bind:src="getCardImage()" v-on:click="cardChoosen"></v-img>
  </v-card>
</template>

<script>
export default {
  props: {
    item: Object,
    socketId: String
  },
  methods: {
    getCardImage: function () {
      return require('@/assets/cards/thumbs/' + this.item.name + '.png')
    },
    cardChoosen: function () {
      this.$socket.emit('vote', Object.assign(this.item, { socketId: this.socketId }))
    }
  }
}
</script>

<style scoped>

#card {
  border-radius: 0.8vw;
}

#card:hover {
  animation: moveUp 0.3s;
  animation-fill-mode: forwards;  
}

@keyframes moveUp {
    0% { transform: translateY(0); }
    100% { transform: translateY(-30px); }
}

</style>
